import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { bool, func, node, oneOfType, string } from 'prop-types';
import { useFela } from 'react-fela';
import { useId } from '../../utils/auto-id';
import { Block } from '../block';
import { Message } from '../message';
import { View } from '../view';
import { checkboxStyle, labelStyle } from './checkbox.style';

const CheckBoxMessages = _ref => {
  let {
    errorMessage,
    description
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, errorMessage ? /*#__PURE__*/React.createElement(Message, {
    type: "error"
  }, errorMessage) : null, description ? /*#__PURE__*/React.createElement(Message, null, description) : null);
};

export const Checkbox = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    isValid = true,
    label,
    errorMessage,
    description,
    ...props
  } = _ref2;
  const {
    theme
  } = useFela();
  const styleProps = {
    isValid,
    theme
  };
  const id = useId('vcc-ui-checkbox', props.id);
  return /*#__PURE__*/React.createElement(View, {
    spacing: 0.5,
    shrink: 1
  }, /*#__PURE__*/React.createElement(View, {
    spacing: 1,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Block, _extends({}, props, {
    ref: ref,
    id: id,
    as: "input",
    type: "checkbox",
    extend: [checkboxStyle(styleProps)]
  })), /*#__PURE__*/React.createElement(Block, {
    as: "label",
    htmlFor: id,
    style: labelStyle(styleProps)
  }, label)), /*#__PURE__*/React.createElement(CheckBoxMessages, {
    description: description,
    errorMessage: errorMessage
  }));
});
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  onChange: func.isRequired,
  checked: bool,
  isValid: bool,
  id: string,
  name: string,
  label: oneOfType([string, node]).isRequired,
  description: string,
  errorMessage: string
};